import errorGenerator from "./customError";
import { HttpStatusCode } from "axios";

const ERROR_MESSAGES = {
  INVALID_CREDENTIALS: "Email or password is incorrect.",

};

export const InvalidCredentialsError = errorGenerator.createApiErrorClass(
  ERROR_MESSAGES.INVALID_CREDENTIALS,
  HttpStatusCode.Forbidden
);

